<template>
<div class="chapter">
<div class="inner_page">
<p class="image0" id="ch-5"><img alt="Image" src="images/24.jpg"/></p>
<h1 class="chapter-no"><a id="page_24"><img alt="Image" src="images/d5.jpg"/></a></h1><a id="page_24">
<h1 class="chapter-title-gr">Mind Makeover</h1>
<p class="line-image"><img alt="Image" src="images/line2.jpg"/></p>
<p class="d-para"><span class="drop-cap"><span class="brwn">W</span></span>e’ve discussed what’s going on behind the walls of our minds. What’ve you noticed going on behind the scenes of the statements you profess?</p>
<p class="indent-para">As a way to help train your mind to see good things, choose one of the statements below and use it as a breath prayer. Meditate on the statement. Inhale and exhale through the words as they run through your mind. This is an excellent way to allow your heart-head to feel what you’re trying to learn instead of arguing for or against what you’ve been taught.</p>
<p class="cen-para"><img alt="Image" src="images/f1.jpg" style="vertical-align:middle;"/> I find rest in the foundation that is Jesus.</p>
<p class="cen-para"><img alt="Image" src="images/f1.jpg" style="vertical-align:middle;"/> Jesus is the One I trust with my worries.</p>
<p class="cen-para"><img alt="Image" src="images/f1.jpg" style="vertical-align:middle;"/> Thank you, Lord—I do not doubt your tender-loving care.</p>
<p class="cen-para"><img alt="Image" src="images/f1.jpg" style="vertical-align:middle;"/> You are peace and goodness. Help me feel you.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012_Chapter05.vue?4a0ecfc8